<div class="container-fluid">
    <div class="row zsd-cust-common-container">
        <div class="col-lg-3 col-xl-3 col-md-12 col-xs-12  col-sm-12"
            [ngClass]="(windowSize < 993  && viewSurveyDetail)? 'hide' : '' ">
            <zsd-surveylist></zsd-surveylist>
        </div>
        <div class="col-lg-9 col-xl-9 col-md-12 col-xs-12 col-sm-12"
            [ngClass]="(windowSize < 993  && !viewSurveyDetail)? 'hide' : '' ">
            <div class="card table-container">
                <div class="card-body">
                    <span style="float: right; color: #0079ef">
                        <em class="fa fa-arrow-left d-block d-lg-none" (click)="showList()"></em>
                    </span>
                    <zsd-surveydetail></zsd-surveydetail>
                </div>
            </div>

        </div>
    </div>
</div>
<router-outlet></router-outlet> 